import { Autocomplete as MuiAutocomplete } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Autocomplete = styled(MuiAutocomplete)`
	border-radius: 12px !important;
`;
